import type {
  LegacyModbusMeter,
  LegacyModbusSerialConfig,
  LegacySerialPortConfig,
  SerialPortConfig,
  TillquistConfig,
} from '@/features/controller/configuration/models/raspiProperties/types'
import {
  ModbusDataType,
  ModbusSerialEncoding,
  SerialPort,
  SerialPortParity,
  WordOrder,
} from '@/features/controller/configuration/models/raspiProperties/types'

/**
 * The only width either serial path supports: RTU requires 8, and the 7-bit modes throw when the
 * port is opened even though they parse, so both drawers keep the field fixed here.
 */
export const SERIAL_DATA_BITS = 8

export const SERIAL_PORT_CONFIG_DEFAULTS: SerialPortConfig = {
  baudRate: 19200,
  dataBits: SERIAL_DATA_BITS,
  parity: SerialPortParity.even,
  stopBits: 1,
}

export const LEGACY_SERIAL_PORT_CONFIG_DEFAULTS: LegacySerialPortConfig = {
  portConfig: SERIAL_PORT_CONFIG_DEFAULTS,
  serialPort: SerialPort.port1,
}

// `satisfies`, so the optional delay keeps its type here: the default for it is a number, whatever
// the model allows a configuration to leave out
export const LEGACY_MODBUS_SERIAL_CONFIG_DEFAULTS = {
  deviceNumber: 1,
  encoding: ModbusSerialEncoding.rtu,
  transmissionDelayInMilliseconds: 1,
} satisfies LegacyModbusSerialConfig

export const TILLQUIST_DEFAULTS: TillquistConfig = {
  frequencyEnabled: false,
  powerEnabled: false,
}

export const MODBUS_METER_DEFAULTS: LegacyModbusMeter = {
  number: 0,
  deviceNumber: 1,
  unitId: 1,
  powerMeasurementSkipPeriodInMilliseconds: 1000,
  powerRegistersDataType: ModbusDataType.INT32,
  registerAddressOffset: 0,
  wordOrder: WordOrder.LITTLE_ENDIAN,
  activePowerScale: 1,
  reactivePowerScale: 1,
  errors: [],
}
